module.exports = __webpack_public_path__ + "portal/assets/img/logo.0980e1d1.svg";